export default {
  ad: 'Annons'
}
